export default "__VITE_ASSET__c7750492__"